module.exports = __webpack_public_path__ + "static/img/step04.fd8a6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step04.png
// module id = KP3C
// module chunks = 1